import { Typography, Box, Stack, useMediaQuery, useTheme, Fade } from '@mui/material';
import FramedApartment from '../../assets/images/FramedApartment.png';
import { LoadingButton } from '@mui/lab';
import { Link } from '../Link';

const TitleAndImageWrapper = ({
  title,
  subtitle,
  image,
  name,
  clickFuntion,
  buttonName,
  link,
  buttonSecondary,
  isLoading,
}: {
  title: string;
  subtitle?: JSX.Element | string;
  image?: string;
  name: string;
  clickFuntion: () => void;
  buttonName: string;
  link?: string;
  buttonSecondary?: boolean;
  isLoading?: boolean;
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const buttonVariant = buttonSecondary ? 'outlined' : 'contained';

  return (
    <Fade in={true}>
      <Box px={4}>
        <Stack direction="column" alignContent="center" alignItems="center">
          <Typography mb={1} variant="h2Iver" align="center" id={`${name}Header`}>
            {title}
          </Typography>
          <Typography align="center" maxWidth={500} id={`${name}SubHeader`}>
            {subtitle}
          </Typography>
          <Link href={`mailto:${link}`}>{link}</Link>
          <LoadingButton
            id={`${name}Button`}
            onClick={clickFuntion}
            loading={isLoading}
            variant={buttonVariant}
            loadingPosition="start"
            startIcon={<div />}
            sx={{ mt: 2 }}
          >
            {buttonName}
          </LoadingButton>

          <img
            id={`${name}Img`}
            style={{
              height: isMobile ? 305 : 520,
            }}
            src={image ? image : FramedApartment}
          />
        </Stack>
      </Box>
    </Fade>
  );
};
export default TitleAndImageWrapper;
